<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Start cash tracking</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="start()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (cash_tracking_session_floats && cash_tracking_session_floats.length != 0) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          @for (float of cash_tracking_session_floats; track float) {
            <ion-grid class="fieldset">
              @if (cash_tracking_session_floats.length > 1) {
                <ion-row>
                  <ion-col>
                    <h3>{{float.title}}</h3>
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <ion-input type="tel" inputmode="decimal" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="float.price">
                    <div slot="label">Float@if (cash_tracking_session_floats.length > 1) {
                      <ion-text class="optional">optional</ion-text>
                    }</div>
                  </ion-input>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="3" labelPlacement="stacked" fill="outline" [(ngModel)]="float.note">
                    <div slot="label">Note<ion-text class="optional">optional</ion-text></div>
                  </ion-textarea>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>